module.exports = __webpack_public_path__ + "static/banner-f60bc33a7d469f6580de40ed1c0b3590.png";